/** Display details for the property a work order or payment belongs to. */
export interface PropertyMeta {
  address: string;
  imageUrl?: string;
  city?: string;
  state?: string;
  zip?: string;
}

/** "Austin, TX 78701" — empty string when none of the parts are known. */
export function formatCityLine(property?: PropertyMeta) {
  const cityState = [property?.city, property?.state].filter(Boolean).join(", ");
  return [cityState, property?.zip].filter(Boolean).join(" ");
}
